import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "clearfix" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", null, "Anställda", -1)
const _hoisted_3 = {
  key: 0,
  class: "row"
}
const _hoisted_4 = { class: "col-12 col-sm mb-1" }
const _hoisted_5 = { class: "col-12 col-sm mb-1" }
const _hoisted_6 = { class: "col-12 col-sm mb-1" }
const _hoisted_7 = { class: "col-12 col-sm mb-1" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Kampanj", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("option", { disabled: "" }, "----------", -1)
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "table-responsive" }
const _hoisted_12 = { class: "table table-striped table-hover" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("th", null, "Kampanj", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("th", { scope: "col" }, null, -1)
const _hoisted_15 = { key: 0 }
const _hoisted_16 = {
  colspan: "5",
  class: "text-center"
}
const _hoisted_17 = { key: 1 }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("td", {
  colspan: "5",
  class: "text-center"
}, "Listan är tom...", -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = ["title", "onClick"]
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { class: "text-end" }
const _hoisted_24 = {
  colspan: "5",
  class: "text-end"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa_icon = _resolveComponent("fa-icon")!
  const _component_messages = _resolveComponent("messages")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("span", _hoisted_1, [
      _createElementVNode("button", {
        class: "float-end btn btn-outline-dark mb-3",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.refresh && _ctx.refresh(...args)))
      }, [
        _createVNode(_component_fa_icon, { icon: "sync-alt" })
      ]),
      _createElementVNode("button", {
        class: "float-end btn btn-outline-dark me-1",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showFilterInput = !_ctx.showFilterInput))
      }, [
        _createVNode(_component_fa_icon, { icon: "search" })
      ]),
      _hoisted_2
    ]),
    _createVNode(_component_messages, { ref: "errorHandler" }, null, 512),
    (_ctx.showFilterInput)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _withDirectives(_createElementVNode("input", {
              type: "search",
              class: "form-control",
              placeholder: "AnstNr",
              "aria-label": "AnstNr",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filter.empNo) = $event))
            }, null, 512), [
              [_vModelText, _ctx.filter.empNo]
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("input", {
              type: "search",
              class: "form-control",
              placeholder: "Förnamn",
              "aria-label": "Förnamn",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filter.firstName) = $event))
            }, null, 512), [
              [_vModelText, _ctx.filter.firstName]
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _withDirectives(_createElementVNode("input", {
              type: "search",
              class: "form-control",
              placeholder: "Efternamn",
              "aria-label": "Efternamn",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filter.lastName) = $event))
            }, null, 512), [
              [_vModelText, _ctx.filter.lastName]
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _withDirectives(_createElementVNode("select", {
              id: "form-campaign",
              class: "form-select",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filter.campaign) = $event))
            }, [
              _hoisted_8,
              _hoisted_9,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.uniqueCampaigns, (c) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: c.id,
                  value: c
                }, _toDisplayString(c.abbreviation), 9, _hoisted_10))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.filter.campaign]
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("table", _hoisted_12, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", {
              scope: "col",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.sort('empNo'))),
              class: _normalizeClass(["sortable", {
              sorted: _ctx.sortBy === 'empNo',
              reverse: _ctx.sortReverse,
            }])
            }, " AnstNr ", 2),
            _createElementVNode("th", {
              scope: "col",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.sort('firstName'))),
              class: _normalizeClass(["sortable", {
              sorted: _ctx.sortBy === 'firstName',
              reverse: _ctx.sortReverse,
            }])
            }, " Förnamn ", 2),
            _createElementVNode("th", {
              scope: "col",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.sort('lastName'))),
              class: _normalizeClass(["sortable", {
              sorted: _ctx.sortBy === 'lastName',
              reverse: _ctx.sortReverse,
            }])
            }, " Efternamn ", 2),
            _hoisted_13,
            _hoisted_14
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_ctx.loadingEmployees)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_15, [
                _createElementVNode("td", _hoisted_16, [
                  _createVNode(_component_fa_icon, {
                    icon: "spinner",
                    spin: ""
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.loadingEmployees && _ctx.employees.length === 0)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_17, _hoisted_19))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.employees, (e) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: e.employeeNumber,
              role: "button",
              title: `Anställningsnummer: ${e.employeeNumber}`,
              onClick: ($event: any) => (_ctx.selectEmployee(e))
            }, [
              _createElementVNode("td", null, _toDisplayString(e.employeeNumber), 1),
              _createElementVNode("td", null, _toDisplayString(e.firstName), 1),
              _createElementVNode("td", null, _toDisplayString(e.lastName), 1),
              (e.activeCampaignAssignments.length > 0)
                ? (_openBlock(), _createElementBlock("td", _hoisted_21, _toDisplayString(e.activeCampaignAssignments.map((ca) => ca.campaign?.abbreviation).join(',')), 1))
                : (_openBlock(), _createElementBlock("td", _hoisted_22, "-")),
              _createElementVNode("td", _hoisted_23, [
                _createVNode(_component_fa_icon, { icon: "pen-to-square" })
              ])
            ], 8, _hoisted_20))
          }), 128))
        ]),
        _createElementVNode("tfoot", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_24, "(" + _toDisplayString(_ctx.employees.length) + " " + _toDisplayString(_ctx.employees.length == 1 ? 'rad' : 'rader') + ")", 1)
          ])
        ])
      ])
    ])
  ], 64))
}